module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item-admin"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("View Product")])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("New Proposals")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Supplier")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Supplier: "), _c('strong', [_vm._v("Phelix Systems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")]), _vm._v(" "), _c('small', [_vm._v("FOB")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277763be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminProposal.vue
// module id = 141
// module chunks = 0